<template>
    <v-container fluid class="container-full-bg-gray">
        <v-snackbar v-model="screen_data.snackbar.isVisible" :color="screen_data.snackbar.color"
            :timeout="screen_data.snackbar.timeout">
            {{ screen_data.snackbar.text }}
        </v-snackbar>
        <app-row :class="hideAllButtons ? 'ma-0' : ''">
            <app-col cols="12" :class="hideAllButtons ? 'pa-0' : ''">
                <v-card width="100%" :class="hideAllButtons ? 'elevation-0' : 'rounded-lg'" :flat="hideAllButtons" v-if="screen_data && screen_data.entityType && screen_data.entityInstance">
                    <v-card-title v-if="!hideAllButtons" class="d-flex">
                        <div class="mr-auto d-flex align-sm-center">
                            <v-btn v-if="!hideDefaultBack" icon @click="backToList">
                                <AppIcon :src="require('../assets/back-arrow.svg')" :size="20" :preserveColors="true"/>
                            </v-btn>
                            <v-tooltip v-if="showPrev" bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon color="primary" @click="prevInstance" v-bind="attrs" v-on="on">
                                        <v-icon>mdi-chevron-left</v-icon>
                                    </v-btn>
                                </template>
                                <span>Anterior</span>
                            </v-tooltip>
                            <v-tooltip v-if="showNext" bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon color="primary" @click="nextInstance" v-bind="attrs" v-on="on">
                                        <v-icon>mdi-chevron-right</v-icon>
                                    </v-btn>
                                </template>
                                <span>Siguiente</span>
                            </v-tooltip>
                        </div>
                        <v-spacer></v-spacer>
                        <div>
                            <v-tooltip v-if="!hideDefaultSave" bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="ml-1 mr-2" icon v-bind="attrs" v-on="on" @click="save()"
                                        :loading="screen_data.loading">
                                        <AppIcon :src="require('../assets/save_invoice.svg')" :size="29" :color-map="{ '060647': 'primary_blue' }"  />
                                    </v-btn>
                                </template>
                                <span>Guardar {{ screen_data.entityType.name }}</span>
                            </v-tooltip>
                        </div>
                    </v-card-title>
                    <v-divider v-if="!hideAllButtons"></v-divider>
                    <v-card-text :class="hideAllButtons ? 'pa-0' : ''" v-if="screen_data && screen_data.entityType && screen_data.entityInstance">
                        <v-row v-if="ui_editor_adhoc_code" :class="hideAllButtons ? 'ma-0' : ''">
                             <v-col cols="12" :class="hideAllButtons ? 'pa-0' : ''">
                                <DynamicComponentRenderer
                                    :key="reloadKey"
                                    :schema="screen_data.entityType.schema"
                                    :code="ui_editor_adhoc_code"
                                    :options="ui_editor_adhoc_options"
                                    v-model="screen_data.entityInstance.payload"
                                    :actions_catalog="actions_catalog"
                                    :company_id="screen_data.entityInstance.company_id"
                                    :delegateActions="['save', 'back', 'reload', 'next', 'prev']"
                                    :showNext="showNext"
                                    :showPrev="showPrev"
                                    @run_action="handleEditorAction"
                                />
                             </v-col>
                        </v-row>
                        <v-row v-else-if="special_ui_type==='00004d7a-e4fe-47af-8ff6-187bca92f300'">
                            <h2>{{ special_ui_payload.note }}</h2>
                            <v-col cols="6" style="color:blue">
                                <RecursivePayloadOnSchemaEditor 
                                :schema="screen_data.entityType.schema" 
                                :key_to_show="screen_data.entityType.name"
                                v-model="screen_data.entityInstance.payload" />
                            </v-col>
                        </v-row>
                        <v-row v-else-if="special_ui_type==='ui-editor-v1'">
                            <h2>{{ special_ui_payload.note }}</h2>
                            <v-col cols="12" >
                                <InstanceEditorV1 v-if="special_ui_payload && screen_data.entityInstance.payload"
                                :my_ui="special_ui_payload" 
                                v-model="screen_data.entityInstance.payload" />
                            </v-col>
                        </v-row>
                        <v-row v-else>
                            <v-col cols="6">
                                <RecursivePayloadOnSchemaEditor 
                                :schema="screen_data.entityType.schema" 
                                :key_to_show="screen_data.entityType.name"
                                v-model="screen_data.entityInstance.payload" />
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card width="100%" class="rounded-lg" v-else-if="singletonNotFound">
                    <v-card-title class="d-flex">
                        <v-btn icon @click="backToList">
                            <AppIcon :src="require('../assets/back-arrow.svg')" :size="20" :preserveColors="true"/>
                        </v-btn>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="text-center py-8">
                        <v-icon size="64" color="grey lighten-1">mdi-information-outline</v-icon>
                        <p class="mt-4 grey--text">No hay instancia configurada</p>
                    </v-card-text>
                </v-card>
            </app-col>
        </app-row>
    </v-container>
</template>

<script>
import AppBtn from "@/components/layout/AppBtn.vue";
import AppRow from "@/components/layout/AppRow.vue";
import AppCol from "@/components/layout/AppCol.vue";
import RecursivePayloadOnSchemaEditor from "@/modules/entities/infra/RecursivePayloadOnSchemaEditor.vue";
import { EntityInstanceEditorScreenData } from "../modules/entities/domain/EntityInstanceEditorScreenData.ts";
import { EntityInstanceEditorComponent } from "@/modules/entities/app/EntityInstanceEditorComponent.ts";
import { EntityTypeApiRepository, EntityInstanceApiRepository } from "../modules/entities/infra/EntitiesApiRepositories";
import InstanceEditorV1 from "@/modules/entities/infra/UIComponents/InstanceEditorV1.vue";
import DynamicComponentRenderer from "../modules/entities/infra/DynamicComponentRenderer.vue";
import { document_components_factory, query_dispatcher_get } from "@/api/client";

export default {
    name: "EntityInstanceEditor",
    components: {
        AppBtn,
        AppCol,
        AppRow,
        InstanceEditorV1,
        RecursivePayloadOnSchemaEditor,
        DynamicComponentRenderer
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.originRoute = from;
        });
    },
    data() {
        const screen_data = new EntityInstanceEditorScreenData();
        return {
            screen_data: screen_data,
            entity_instance_component: null,
            reloadKey: 0,
            originRoute: null,
            singletonNotFound: false
        };
    },
    props: {
        companydb_id: {
            type: [Number, String],
            required: true,
            default: null
        },
        entity_instance_id: {
            type: String,
            required: false,
            default: null
        },
        entity_type_id: {
            type: String,
            required: false,
            default: null
        },
        singleton: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    methods: {
        backToList() {
            if (this.originRoute && this.originRoute.name) {
                this.$router.push(this.originRoute);
            } else {
                this.$router.go(-1);
            }
        },
        async save() {
            await this.entity_instance_component.saveEntityInstance();
            if (!this.singleton) {
                this.$router.replace({ name: 'entity-instance-editor', params: { 'companydb_id': this.companydb_id, 'entity_instance_id': this.screen_data.entityInstance.uuid } });
            }
        },
        async handleEditorAction(action_code) {
            if (action_code === 'save') {
                this.save();
            } else if (action_code === 'auto_save') {
                this.autoSave();
            } else if (action_code === 'back') {
                this.backToList();
            } else if (action_code === 'reload') {
                await this.entity_instance_component.reloadInstance();
                this.reloadKey++;
            } else if (action_code === 'next') {
                this.nextInstance();
            } else if (action_code === 'prev') {
                this.prevInstance();
            }
        },
        async autoSave() {
            await this.entity_instance_component.saveEntityInstance();
            // Don't navigate away, just update the URL if needed
            if (!this.entity_instance_id && this.screen_data.entityInstance.uuid) {
                this.$router.replace({ name: 'entity-instance-editor', params: { 'companydb_id': this.companydb_id, 'entity_instance_id': this.screen_data.entityInstance.uuid } });
            }
        },
        // Navigation methods
        async nextInstance() {
            const { next } = this.next_and_previous_instance;
            if (next === null && this.there_are_more_pages) {
                // Load next page, navigate to first item
                this.list_component.screen_data.tableOptions.page += 1;
                await this.list_component.loadInstances();
                const firstInstance = this.list_component.screen_data.instances[0];
                if (firstInstance && firstInstance.__row_id__) {
                    await this.changeInstance(firstInstance.__row_id__);
                }
            } else if (next) {
                await this.changeInstance(next);
            }
        },
        async prevInstance() {
            const { previous } = this.next_and_previous_instance;
            if (previous === null && this.im_not_in_first_page) {
                // Load previous page, navigate to last item
                this.list_component.screen_data.tableOptions.page -= 1;
                await this.list_component.loadInstances();
                const instances = this.list_component.screen_data.instances;
                const lastInstance = instances[instances.length - 1];
                if (lastInstance && lastInstance.__row_id__) {
                    await this.changeInstance(lastInstance.__row_id__);
                }
            } else if (previous) {
                await this.changeInstance(previous);
            }
        },
        async changeInstance(uuid) {
            this.$router.push({ name: 'entity-instance-editor', params: { companydb_id: this.companydb_id, entity_instance_id: uuid } });
            // Reload instance data
            await this.entity_instance_component.mountInstanceEditor(uuid, null);
            this.reloadKey++;
        },
    },
    computed:{
        special_ui_type(){
            if(this.screen_data.entityType.ui_config && this.screen_data.entityType.ui_config.entity_editor){
                return this.screen_data.entityType.ui_config.entity_editor.ui_type
            }
            return null
        },
        special_ui_payload(){
            if(this.screen_data.entityType.ui_config && this.screen_data.entityType.ui_config.entity_editor){
                return this.screen_data.entityType.ui_config.entity_editor.payload
            }
            return null
        },
        isCreating() {
            // Creating if no entity_instance_id prop was passed (we came with entity_type_id only)
            return !this.entity_instance_id && this.entity_type_id;
        },
        hasCreateTemplate() {
            return this.screen_data.entityType &&
                   this.screen_data.entityType.ui_config &&
                   this.screen_data.entityType.ui_config.create_template;
        },
        ui_editor_adhoc_code(){
            if(this.screen_data.entityType.ui_config){
                // Use create_template if creating and it exists, otherwise use editor_template
                if(this.isCreating && this.hasCreateTemplate){
                    return this.screen_data.entityType.ui_config.create_template;
                }
                if(this.screen_data.entityType.ui_config.editor_template){
                    return this.screen_data.entityType.ui_config.editor_template;
                }
            }
            return null
        },
        ui_editor_adhoc_options(){
            if(this.screen_data.entityType.ui_config){
                // Use create_options if creating and it exists, otherwise use editor_options
                if(this.isCreating && this.screen_data.entityType.ui_config.create_options){
                    return this.screen_data.entityType.ui_config.create_options;
                }
                return this.screen_data.entityType.ui_config.editor_options || '';
            }
            return '';
        },
        actions_catalog(){
        if (this.screen_data.entityType && this.screen_data.entityType.actions_catalog) {
          return this.screen_data.entityType.actions_catalog;
        }
        return [];
      },
        hideDefaultSave() {
            return this.screen_data.entityType && this.screen_data.entityType.ui_config && this.screen_data.entityType.ui_config.hide_default_save === true;
        },
        hideDefaultBack() {
            return this.screen_data.entityType && this.screen_data.entityType.ui_config && this.screen_data.entityType.ui_config.hide_default_back === true;
        },
        hideAllButtons() {
            return this.hideDefaultSave && this.hideDefaultBack;
        },
        // Navigation computed properties
        entity_type_uuid() {
            // Use prop if creating, or instance's entity_type_id if editing
            if (this.entity_type_id) return this.entity_type_id;
            if (this.screen_data && this.screen_data.entityInstance && this.screen_data.entityInstance.entity_type_id) {
                return this.screen_data.entityInstance.entity_type_id;
            }
            return null;
        },
        list_component() {
            if (!this.entity_type_uuid) return null;
            return document_components_factory.get_or_create_entity_instances_view_component(this.entity_type_uuid);
        },
        next_and_previous_instance() {
            let next = null;
            let previous = null;

            // Safety checks - if list not loaded or instance not in list, return nulls (no arrows)
            if (!this.list_component || !this.list_component.screen_data || !this.list_component.screen_data.instances || !this.list_component.screen_data.instances.length) {
                return { next, previous };
            }
            if (!this.screen_data || !this.screen_data.entityInstance || !this.screen_data.entityInstance.uuid) {
                return { next, previous };
            }

            const instances = this.list_component.screen_data.instances;
            const currentUuid = this.screen_data.entityInstance.uuid;

            // Find current instance in the list
            const index = instances.findIndex(inst => inst.__row_id__ === currentUuid);

            // If not found (direct URL access or different filter), no arrows
            if (index === -1) return { next, previous };

            // Get adjacent instances
            if (index + 1 < instances.length) {
                next = instances[index + 1].__row_id__;
            }
            if (index > 0) {
                previous = instances[index - 1].__row_id__;
            }

            return { next, previous };
        },
        im_not_in_first_page() {
            if (!this.list_component || !this.list_component.screen_data || !this.list_component.screen_data.tableOptions) {
                return false;
            }
            return this.list_component.screen_data.tableOptions.page > 1;
        },
        there_are_more_pages() {
            if (!this.list_component || !this.list_component.screen_data || !this.list_component.screen_data.tableOptions) {
                return false;
            }
            const { page, itemsPerPage } = this.list_component.screen_data.tableOptions;
            return (page * itemsPerPage) < this.list_component.screen_data.totalCount;
        },
        showPrev() {
            if (this.singleton) return false;
            return this.next_and_previous_instance.previous !== null || this.im_not_in_first_page;
        },
        showNext() {
            if (this.singleton) return false;
            return this.next_and_previous_instance.next !== null || this.there_are_more_pages;
        }
    },
    async mounted() {
        this.entity_instance_component = new EntityInstanceEditorComponent(new EntityTypeApiRepository(), this.screen_data, new EntityInstanceApiRepository(), this.companydb_id);

        if (this.singleton) {
            // Resolve singleton instance via backend query
            try {
                let result = await query_dispatcher_get.dispatch('get.singleton.instance', {
                    entity_type_id: this.entity_type_id,
                    company_id: parseInt(this.companydb_id)
                });
                if (result && result.status === 'found' && result.instance) {
                    // Load the found singleton instance
                    await this.entity_instance_component.mountInstanceEditor(result.instance.uuid, null);
                    // Show instance uuid in the URL
                    this.$router.replace({ name: 'entity-singleton', params: { companydb_id: this.companydb_id, entity_type_uuid: this.entity_type_id, entity_instance_id: this.screen_data.entityInstance.uuid } });
                } else {
                    // No instance and no get_or_create — show not found
                    this.singletonNotFound = true;
                }
            } catch (error) {
                console.error('Error resolving singleton instance:', error);
                this.singletonNotFound = true;
            }
        } else {
            let well_mounted = await this.entity_instance_component.mountInstanceEditor(this.entity_instance_id, this.entity_type_id);
            if(!well_mounted){
                this.backToList()
            }
        }
    },

};
</script>

<style scoped>
</style>